<template>
  <div class="register">
    <header>
      <div class="g-header">
        <div class="left">
          <div class="close-btn" @click="changeHome">
            <i class="icon-x"></i>
          </div>
        </div>
        <div class="middle fs-18">
          <div class="title">{{ $t("zhuce") }}</div>
        </div>
      </div>
    </header>
    <div class="g-content flex-column">
      <div class="register-main">
        <van-cell-group class="login-body van-cell-group">
          <div class="field-row">
            <div class="field-label">账号</div>
            <van-field
              placeholder="请输入用户名"
              v-model="username"
              clearable
            >
            </van-field>
          </div>
          <div class="field-row">
            <div class="field-label">手机号码</div>
            <van-field
              placeholder="手机号码"
              v-model="phone"
              clearable
            >
            </van-field>
          </div>
          <div class="field-row">
            <div class="field-label">密码</div>
            <van-field
              clearable
              placeholder="请输入密码"
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
            >
            </van-field>
            <div class="eye-icon" @click="togglePasswordVisibility">
              <img v-if="showPassword" :src="eyeOpenIcon" alt="隐藏密码" />
              <img v-else :src="eyeCloseIcon" alt="显示密码" />
            </div>
          </div>
          <div class="field-row">
            <div class="field-label">确认密码</div>
            <van-field
              clearable
              placeholder="请输入确认密码"
              :type="showConfirmPassword ? 'text' : 'password'"
              v-model="confirmPassword"
            >
            </van-field>
            <div class="eye-icon" @click="toggleConfirmPasswordVisibility">
              <img v-if="showConfirmPassword" :src="eyeOpenIcon" alt="隐藏密码" />
              <img v-else :src="eyeCloseIcon" alt="显示密码" />
            </div>
          </div>
        </van-cell-group>
        <div class="register-bottom">
          <div>
            <van-button
              type="primary"
              round
              block
              class="Btnlogin"
              @click="ChangeRegister"
              >创建账号</van-button
            >
            <div class="has-acoount">
              <span>已有账户?</span>
              <span class="btn-tologin" @click="changeLogin">请登录</span>
            </div>
          </div>

          <!-- <p>{{ $t("dangqianbanben") }}：21.04.02</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import loginApi from "@/api/login";
import storeAction from "@/store/typed-actions";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      username: "",
      phone: "",
      password: "",
      confirmPassword: "",
      inviter_id: "",
      showPassword: false,
      showConfirmPassword: false,
      eyeCloseIcon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII=",
      eyeOpenIcon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkchXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC",
    };
  },
  methods: {
    changeLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    changeHome() {
      this.$router.push({
        path: "/",
      });
    },
    ChangeRegister() {
      // 验证账号长度（最少5位）
      if (!this.username) {
        this.$toast('请输入用户名');
        return;
      } else if (this.username.length < 5) {
        this.$toast('账号最少需要5位');
        return;
      }
      
      // 验证手机号格式
      if (!this.phone) {
        this.$toast('请输入手机号码');
        return;
      } else if (!this.validatePhone(this.phone)) {
        this.$toast('请输入正确的手机号码');
        return;
      }
      
      // 验证密码长度（最少6位）
      if (!this.password) {
        this.$toast('请输入密码');
        return;
      } else if (this.password.length < 6) {
        this.$toast('密码最少需要6位');
        return;
      }
      
      // 验证确认密码
      if (!this.confirmPassword) {
        this.$toast('请输入确认密码');
        return;
      } else if (this.password !== this.confirmPassword) {
        this.$toast('两次输入的密码不一致');
        return;
      }
      
      // 所有验证通过，执行注册
      loginApi
        .register(this.username, this.password, this.phone, "1", this.inviter_id)
        .then((data) => {
          console.log(data.data, "注册成功");
          storeAction.loginDone(data.data);
        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast.fail(err.msg);
        });
    },
    // 手机号验证方法
    validatePhone(phone) {
      // 中国大陆手机号正则表达式
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(phone);
    },
    // 切换密码显示状态
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    // 切换确认密码显示状态
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
  },
  mounted() {
    // http://localhost:8080/register?inviter_id=37
    console.log(this.$route.query.inviter_id);
    this.inviter_id = this.$route.query.inviter_id;
  },
};
</script>
<style lang="less" scoped>
.register {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  min-height: 100%;
}
.g-header {
  position: absolute;
  width: 100%;
  height: 1.18rem;
  text-align: center;
  z-index: 1;
  color: #fff;
  background: #161936;
}
.left {
  z-index: 11;
  position: absolute;
  height: 100%;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.close-btn {
  padding: 0.3rem;
}
.icon-x {
  display: inline-block;
  width: 0.5rem;
  height: 0.07rem;
  background: #fff;
  line-height: 0;
  font-size: 0;
  vertical-align: middle;
  transform: rotate(45deg);
}
.icon-x::after {
  content: "";
  display: block;
  width: 0.5rem;
  height: 0.07rem;
  background: #fff;
  transform: rotate(-90deg);
}
.middle {
  z-index: 10;
  max-width: 80%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.fs-18 {
  font-size: 0.43rem;
}
.title {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.register-main {
  flex: 1;
  padding: 1.9rem 0.5rem 0.5rem;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  color: #a0a0a0;
  text-align: center;
}
.login-body {
  // margin-top: 1.7rem;
  // padding: 0 0.68rem;
}
.van-cell-group {
  background: unset;
  position: unset;
}

.field-row {
  display: flex;
  align-items: center;
  margin-top: 0.7rem;
  padding: 0 0.68rem;
  position: relative;
}

.field-label {
  text-align: left;
  font-size: 0.37rem;
  color: #fff;
  min-width: 1.8rem;
  flex-shrink: 0;
}

.van-cell {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  overflow: hidden;
  color: unset;
  font-size: 14px;
  line-height: 24px;
  background-color: unset;
}

.field-row .van-field {
  background: none !important;
  padding: 0 0.5rem .2rem;
  flex: 1;
  // margin-left: 0.5rem;
  position: relative;
  border-bottom: .01667rem solid #fff;
  border-radius: .08rem;
}

.van-field input {
  background: none !important;
  color: #fff;
  font-size: 0.4rem;
  padding-left: 10px;
  text-indent: 0;
}

:deep(.van-field input::placeholder) {
  color: #757575 !important;
  font-size: 0.4rem !important;
  // text-indent: 10px !important;
}

/* 更强的选择器确保样式生效 */
:deep(.register .field-row .van-field input::placeholder) {
  color: #757575 !important;
  font-size: 0.4rem !important;
  // text-indent: 10px !important;
}

:deep(.register .field-row .van-field input::-webkit-input-placeholder) {
  color: #757575 !important;
  font-size: 0.4rem !important;
  // text-indent: 10px !important;
}

:deep(.register .field-row .van-field input::-moz-placeholder) {
  color: #757575 !important;
  font-size: 0.4rem !important;
  // text-indent: 10px !important;
}


.field-row .van-field::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
}

.van-field::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
}
.left-form-icon {
  width: 20px;
}
.c_a0a0a0 {
  color: #a0a0a0;
}
.register-bottom {
  margin-top: 1.5rem;
  flex: 1;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  // padding: 0 0.68rem;
}
.Btnlogin {
  color: #fff;
  background: rgb(14, 162, 255) !important;
  border: 1px solid rgb(14, 162, 255) !important;
}
.has-acoount {
  margin-top: 0.2rem;
}
.btn-tologin {
  margin-left: 0.3rem;
  color: #4bb3e8;
}
.input {
    border-bottom: .02667rem solid #fff;
}
.my-field {
  :deep(input::placeholder) {
    color: #999;        /* 颜色 */
    font-size: 20px;    /* 字体大小 */
    text-align: center; /* 位置（居中/右等） */
  }
}

.eye-icon {
  position: absolute;
  right: 1rem;
  top: 30%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
  
  img {
    width: 0.6rem;
    // height: 0.6rem;
    opacity: 0.7;
    transition: opacity 0.3s ease;
    
    &:hover {
      opacity: 1;
    }
  }
}
</style>